import { Directive } from '@angular/core';

/** Marks a table's own empty-state content, so `ptl-data-table` can tell whether one was projected. */
@Directive({
  selector: '[ogTableEmpty]',
})
export class PtlTableEmptyDirective {}
